import { createTableSlice } from '../helpers';

export const tableSlice = createTableSlice({
  name: 'dataCurationDashboard/labellingCandidatesTable',
  url: '/api/rawSequences/notScreened',
  sortOrder: 'desc',
  orderBy: 'RawSequence.id',
});
